module.exports = __webpack_public_path__ + "assets/Instagram-minimal.5e985626.svg";